<div [formGroup]="form" class="flex flex-col gap-3 p-4">
    <!-- Pulsante aggiungi -->
    <div class="flex mb-3" style="justify-content: flex-end;">
        <button type="button" pButton icon="pi pi-plus" label="Aggiungi intervento" severity="success" (click)="addIntervento()"></button>
    </div>

    <!-- Lista interventi -->
    <div formArrayName="interventi" class="flex flex-col gap-4">
        <div *ngIf="isLoadingImage" class="flex justify-center my-6">
            <p-progressSpinner styleClass="w-12 h-12"></p-progressSpinner>
        </div>
        <div *ngFor="let interv of interventi.controls; let i = index" [formGroupName]="i" class="p-4 flex flex-col gap-3 shadow-sm bg-white rounded-md">
            <div *ngIf="!isLoadingImage" class="flex items-center justify-between gap-3">
                <!-- Titolo -->
                <div class="font-semibold whitespace-nowrap">Intervento {{ i + 1 }}</div>

                <!-- Input note al centro -->
                <input type="text" pInputText formControlName="noteInterventoRilevatore" placeholder="Note intervento..." class="flex-1 min-w-0 px-3 py-2 border border-gray-300 rounded-md" />

                <!-- Pulsanti a destra -->
                <div class="flex gap-2 flex-shrink-0">
                    <button type="button" pButton icon="pi pi-eye" severity="help" (click)="openInterventoImage(i)" *ngIf="interv.get('existFile')?.value === true"></button>
                    <button type="button" pButton icon="pi pi-camera" severity="info" (click)="openCamera(i, interv)" *ngIf="interv?.get('existFile')?.value === false && interv?.get('id')?.value"></button>
                    <button type="button" pButton icon="pi pi-trash" severity="danger" (click)="removeIntervento(i, interv)"></button>
                </div>
            </div>
        </div>
    </div>

    <!-- Webcam dialog -->
    <p-dialog [(visible)]="showWebcam" [modal]="true" header="Scatta foto intervento" [style]="{ width: '70vw' }">
        <div class="flex flex-col items-center justify-center min-h-[300px]">
            <webcam *ngIf="!isUploading && !previewImage" [trigger]="triggerObservable" (imageCapture)="handleImage($event)"> </webcam>

            <p-progressSpinner *ngIf="isUploading" styleClass="w-12 h-12 mt-4"> </p-progressSpinner>

            <div *ngIf="previewImage" class="mt-4">
                <img [src]="previewImage" alt="Preview" class="max-h-[300px] rounded shadow" />
            </div>
        </div>

        <ng-template pTemplate="footer">
            <div class="flex justify-end gap-2">
                <button pButton label="Chiudi" icon="pi pi-times" (click)="showWebcam = false"></button>
                <button pButton label="Scatta" icon="pi pi-camera" severity="success" (click)="captureImage()"></button>
            </div>
        </ng-template>
    </p-dialog>
</div>

<p-confirmDialog></p-confirmDialog>
